import SendDeletionRequestConstants from './constants';

export const openSendDeletionRequestModal = () => ({
  type: SendDeletionRequestConstants.OPEN_MODAL,
});

export const closeSendDeletionRequestModal = () => ({
  type: SendDeletionRequestConstants.CLOSE_MODAL,
});

export const sendDeletionRequest = (reason: string, contactNumber: string) => ({
  reason,
  contactNumber,
  type: SendDeletionRequestConstants.SEND_DELETION_REQUEST,
});
